import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { RouterLink } from '@angular/router';
import { NgIf } from '@angular/common';
import { faStar } from "@fortawesome/free-solid-svg-icons";
import { GetProductDetailQuery } from '../../common/gql/graphql';
import { ProductReviewListComponent } from '../product-review-list/product-review-list.component';
import { ProductReviewHistogramComponent } from '../product-review-histogram/product-review-histogram.component';
import { ProductReviewRatingLargeComponent } from '../product-review-rating-large/product-review-rating-large.component';
import { SectionHeaderComponent } from '../../../shared/components/section-header/section-header.component';

@Component({
    selector: 'kb-top-reviews',
    templateUrl: './top-reviews.component.html',
    styleUrls: ['./top-reviews.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
        SectionHeaderComponent,
        NgIf,
        ProductReviewRatingLargeComponent,
        ProductReviewHistogramComponent,
        RouterLink,
        ProductReviewListComponent,
        FontAwesomeModule,
    ],
})
export class TopReviewsComponent {
    @Input() rating: number;
    @Input() reviewsData: NonNullable<GetProductDetailQuery['product']>['reviews'];
    @Input() histogramData: NonNullable<GetProductDetailQuery['product']>['reviewsHistogram'];
    star = faStar;
}
